import React, { useState } from "react";
import { SearchGrayIcon } from "../common/Icon";
import { BlogContenDtata } from "../common/Helper";
import { useStateProvider } from "../common/StateProvider";
import { useNavigate } from "react-router-dom";

const BlogsData = () => {
  const navigate = useNavigate();
  const { setCardData } = useStateProvider();
  // const [setShowBlog] = useState(false);

  const [filteredBlog, setFilteredBlog] = useState(BlogContenDtata);
  const inputChangeHandler = (value) => {
    const Data = BlogContenDtata.filter((obj) => {
      return obj.blogheading.toLowerCase().includes(value.toLowerCase());
    });
    setFilteredBlog(Data);
  };

  const readMoreHandler = (value, index) => {
    navigate(`/blog-description/${index}`);
    // setShowBlog(true);
    localStorage.setItem("items", JSON.stringify(value));
    setCardData(value);
  };
  return (
    <>
      <div className="px-5 pr-[12px] xm:pr-5 bg-white rounded-[20px] overflow-hidden  shadow-my_contacts_tabs_shadow  3xl:w-full">
        <div className="flex border border-[#f2f2f2] rounded-[31px] py-[11px] px-[15px] sm:w-[348px] 2xl:w-[400px] mt-4 md:mt-6 mb-[22px]">
          <SearchGrayIcon />
          <input
            onChange={(e) => inputChangeHandler(e.target.value)}
            className="outline-none border-none font-normal text-xs text-black placeholder:text-gray pl-3 w-full"
            type="search"
            placeholder="Search here..."
          />
        </div>
        <div className="flex flex-wrap overflow-y-auto gap-4 lg:gap-6 xl:gap-7 h-[calc(100vh-280px)] md:h-[calc(100vh-220px)] overflow_x_scroll_style pr-2 xm:pr-0 mb-4">
          {filteredBlog.map((obj, index) => (
            <div
              key={index}
              className={`overflow-hidden object-cover w-full xm:max-w-[48%] md:max-w-[31%] min-[1500px]:max-w-[31.5%] min-[1800px]:max-w-[32%] border border-[#f2f2f2] rounded-[20px] my-2 md:my-0 ${
                index === 2
                  ? " "
                  : index === 5
                  ? ""
                  : index === 1
                  ? ""
                  : index === 3
                  ? ""
                  : ""
              }`}>
              <a href="#">
                <img
                  className="w-full"
                  width={310}
                  height={201}
                  loading="lazy"
                  src={obj.blogimg1}
                  alt="all-blogs-img"
                />

                <div className="p-3 xl:p-[18px]">
                  <h3 className="xl:pt-0.5 font-bold text-sm xl:text-base text-black">
                    {obj.blogheading}
                  </h3>
                  <p className="text-xs xl:text-sm font-normal text-black mt-3 md:mt-5">
                    {obj.blogpara}
                  </p>

                  <button
                    onClick={() => readMoreHandler(obj, index)}
                    className="py-[7px] px-7 rounded-3xl mt-2.5 text-primary bg-[#f3f3fe] text-xs font-normal hover:bg-primary hover:text-white transition-all ease-in-out duration-300">
                    {obj.blogbtn}
                  </button>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BlogsData;
